<template>
  <v-container id="conciliacao-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :progresso="progresso"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ConciliacaoService from '@/services/ConciliacaoService';
  import dayjs from 'dayjs';
  import pusherMixins from '@/mixins/pusherMixins';

  const INTERVALO_PROGRESSO_MS = 3000;
  const STATUS_ATIVOS = ['AGUARDANDO', 'EXECUTANDO'];

  export default {
    components: {
      Tabela: () => import('@/components/conciliacoesV3/Tabela.vue')
    },
    mixins: [pusherMixins],

    data: () => ({
      items: [],
      loading: false,
      processamentosExpirados: false,
      progresso: {},
      timerProgresso: null
    }),

    mounted() {
      this.getAll();
      this.subscribe();
    },

    beforeDestroy() {
      clearTimeout(this.timerProgresso);
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshConciliacoesV3', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;
        ConciliacaoService.getAll(this.processamentosExpirados)
          .then(({ data }) => {
            const records = Array.isArray(data?.data) ? data.data : [];
            this.items = records.map((item) => ({
              id: item.id,
              nome: item.nome,
              tipo: item.tipo,
              status: item.status,
              versao: item.versao,
              conciliacaoIdExterno: item.conciliacao_id_externo,
              execucaoIdExterno: item.execucao_id_externo,
              usuario: item.usuario?.nome || '-',
              created: item.created ? dayjs(item.created).format('DD/MM/YYYY HH:mm') : '-',
              executed: item.data_processamento
                ? dayjs(item.data_processamento).format('DD/MM/YYYY HH:mm')
                : '-'
            }));
            this.agendarProgresso();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao carregar conciliações.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      agendarProgresso() {
        clearTimeout(this.timerProgresso);
        this.timerProgresso = null;
        if (!this.items.some((item) => STATUS_ATIVOS.includes(item.status))) return;
        this.timerProgresso = setTimeout(this.atualizarProgresso, INTERVALO_PROGRESSO_MS);
      },
      async atualizarProgresso() {
        const ativos = this.items.filter((item) => STATUS_ATIVOS.includes(item.status));
        // Sem execução criada ainda, o back responde 400: ignora e tenta no próximo ciclo.
        const respostas = await Promise.all(
          ativos.map((item) =>
            ConciliacaoService.progresso(item.id)
              .then(({ data }) => ({ item, ...data.data }))
              .catch(() => null)
          )
        );
        if (this._isDestroyed) return;

        let finalizou = false;
        respostas.filter(Boolean).forEach(({ item, entity, progresso }) => {
          this.$set(this.progresso, item.id, progresso || null);
          if (entity?.status && entity.status !== item.status) {
            item.status = entity.status;
            if (!STATUS_ATIVOS.includes(entity.status)) finalizou = true;
          }
        });

        if (finalizou) {
          this.getAll();
        } else {
          this.agendarProgresso();
        }
      }
    }
  };
</script>
